module.exports = ".form-control-auto-save {\n  position: relative; }\n\n.invalid-wrapper {\n  color: #F44336; }\n\n.loading {\n  position: absolute;\n  right: 0;\n  padding: 10px; }\n\n.done {\n  position: absolute;\n  right: 0;\n  font-weight: bold;\n  color: green;\n  padding: 10px; }\n\n.done mat-icon {\n    color: green; }\n\n.error-icon {\n  font-weight: bold; }\n\n.error-icon mat-icon {\n    color: #F44336; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pillar/workspace/components/form-control-auto-save.component.scss
// module id = ./src/app/pillar/workspace/components/form-control-auto-save.component.scss
// module chunks = main